import { Link } from "react-router-dom";

const contentLinks = [
  { label: "动漫资讯", to: "/news" },
  { label: "作品推荐", to: "/works" },
  { label: "剧情解析", to: "/analysis" },
  { label: "动漫文化", to: "/culture" },
];

const aboutLinks = [
  { label: "关于我们", to: "/about" },
  { label: "站内搜索", to: "/search" },
  { label: "使用须知", to: "/about" },
  { label: "反馈渠道", to: "/about" },
];

const friendLinks = [
  { label: "动漫周报", href: "https://911gugu3.asia" },
  { label: "二次元观察", href: "https://911gugu3.asia" },
  { label: "作画资料馆", href: "https://911gugu3.asia" },
  { label: "配音爱好者协会", href: "https://911gugu3.asia" },
];

export default function SiteFooter() {
  return (
    <footer className="mt-16 bg-primary-950 text-background-100">
      <div className="mx-auto max-w-page px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500">
                <i className="ri-planet-fill text-xl text-accent-300" />
              </span>
              <span className="font-heading text-lg font-bold text-background-50">星空动漫</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-200">
              专业的动漫内容门户，提供最新动漫资讯、作品推荐、剧情解析与行业动态，陪你在星空下畅享动漫世界。
            </p>
          </div>

          <div>
            <h3 className="mb-4 text-sm font-semibold text-background-50">内容导航</h3>
            <ul className="space-y-2.5">
              {contentLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="cursor-pointer text-sm text-background-200 transition-colors hover:text-accent-300"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="mb-4 text-sm font-semibold text-background-50">网站信息</h3>
            <ul className="space-y-2.5">
              {aboutLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="cursor-pointer text-sm text-background-200 transition-colors hover:text-accent-300"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="mb-4 text-sm font-semibold text-background-50">联系我们</h3>
            <ul className="space-y-2.5 text-sm text-background-200">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-base text-accent-300" />
                contact@staranime.example
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-wechat-line text-base text-accent-300" />
                微信公众号：星空动漫
              </li>
            </ul>
            <div className="mt-4 flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-primary-800 text-accent-200">
                <i className="ri-weibo-line" />
              </span>
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-primary-800 text-accent-200">
                <i className="ri-bilibili-line" />
              </span>
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-primary-800 text-accent-200">
                <i className="ri-youtube-line" />
              </span>
            </div>
          </div>
        </div>

        <div className="mt-10 border-t border-primary-800 pt-6">
          <div className="mb-4">
            <h4 className="mb-2 text-xs font-semibold text-background-300">
              <Link to="/about" className="cursor-pointer hover:text-accent-300">
                友情链接
              </Link>
            </h4>
            <div className="flex flex-wrap gap-x-4 gap-y-2">
              {friendLinks.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="cursor-pointer text-xs text-background-300 transition-colors hover:text-accent-300"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>
          <div className="flex flex-col gap-2 text-xs text-background-300 sm:flex-row sm:items-center sm:justify-between">
            <p>© 2026 星空动漫 Star Anime. 本站为内容演示站点，所有作品与资讯均为示例内容。</p>
            <p>本站不提供任何影视资源下载，所有内容仅用于资讯与文化交流。</p>
          </div>
        </div>
      </div>
    </footer>
  );
}